module.exports = __webpack_public_path__ + "static/media/icon_datasource.3209c5c7.svg";